(function () {
  const drawer = document.getElementById('elarys-cart-drawer');
  const overlay = document.getElementById('elarys-cart-overlay');
  const itemsContainer = document.getElementById('elarys-cart-items');
  const subtotalElement = document.getElementById('elarys-cart-subtotal');
  const countElement = document.getElementById('elarys-cart-count');

  if (!drawer || !overlay || !itemsContainer) return;

  const root = window.Shopify && window.Shopify.routes
    ? window.Shopify.routes.root
    : '/';

  let activeCurrency = 'EUR';

  function formatMoney(cents) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: activeCurrency
    }).format((cents || 0) / 100);
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function openDrawer() {
    overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  async function getCart() {
    const response = await fetch(root + 'cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    });

    return response.json();
  }

  function renderCart(cart) {
    activeCurrency = cart.currency || activeCurrency;

    countElement.textContent = cart.item_count;
    subtotalElement.textContent = formatMoney(cart.total_price);

    if (!cart.items || cart.items.length === 0) {
      itemsContainer.innerHTML = '<p>Votre panier est vide.</p>';
      return;
    }

    itemsContainer.innerHTML = cart.items.map(function (item) {
      const image = item.image
        ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}">`
        : '';

      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="elarys-cart-item__variant">${escapeHtml(item.variant_title)}</p>`
        : '';

      return `
        <div class="elarys-cart-item">
          ${image}
          <div class="elarys-cart-item__info">
            <p class="elarys-cart-item__title">${escapeHtml(item.product_title)}</p>
            ${variant}
            <p class="elarys-cart-item__variant">Quantité : ${item.quantity}</p>
            <p class="elarys-cart-item__price">${formatMoney(item.final_line_price)}</p>
          </div>
        </div>
      `;
    }).join('');
  }

  async function refreshAndOpenCart() {
    const cart = await getCart();
    renderCart(cart);
    openDrawer();
  }

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('form[action*="/cart/add"]');

    if (!form) return;

    event.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');
    const originalText = submitButton ? submitButton.textContent : '';

    try {
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Ajout...';
      }

      const formData = new FormData(form);

      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const error = await response.json();
        alert(error.description || 'Impossible d’ajouter ce produit au panier.');
        return;
      }

      await refreshAndOpenCart();

    } catch (error) {
      console.error(error);
      alert('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalText;
      }
    }
  });

  overlay.addEventListener('click', closeDrawer);

  document.querySelectorAll('[data-elarys-close-cart]').forEach(function (button) {
    button.addEventListener('click', closeDrawer);
  });
})();